import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS, GET_USER_BY_ROLES, GET_SCRUTINIZER_BY_SUPERVISOR_ID, GET_USER, GET_USER_DETAILS } from '../../common/URLs';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { ROLES } from '../../common/constants';
import { loaderService } from "../../common/custom-loader/loader-service";
import ScrutinyDetails from './Registration-Incharge/scrutinyDetails';
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Fab } from '@mui/material';
import { PROD } from '../../common/constants';
import { Box, CardContent, Card, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import Link from "@mui/material/Link";
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { useTranslation } from "react-i18next";
import apiClient from "../../axios";

function SuperVisorDashboard() {
  const { t } = useTranslation();
  const [userID, setUserId] = useState();
  const [role, setRole] = useState();
  const [scrutinizers, setScrutinizers] = useState();
  const [scrutinizersBySupervisor, setScrutinizerBySupervisor] = useState();
  const [scrutinizerID, setScrutinizerID] = useState();
  const [showMapping, setShowMapping] = useState(false);
  const [emailId, setEmailId] = useState();
  const [userDetails, setUserDetails] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    getAllScrutinizersBySupervisor()
  },[])

  const viewMappingDetails = (scrutinizerID) => {
    setScrutinizerID(scrutinizerID);
    setShowMapping(true);
  }
useEffect(() => {
  if (getLocalStorageItem('id_token')) {
    const decoded = jwt(getLocalStorageItem('id_token'));

    const email = decoded.emails?.[0];
    setEmailId(email);


  }
}, [getLocalStorageItem('id_token')]);
useEffect(() => {
  if (emailId) {
    getUserDetails();
  }
}, [emailId]);
function getUserDetails() {
  apiClient
    .post(GET_USER_DETAILS,
      {
        "emailAddress": emailId
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUserDetails(response.data?.user);
    })
    .catch(function (error) {
      console.log(error);
    });
}
useEffect(() => {
  if (userDetails) {
    getAllScrutinizersBySupervisor();
  }
}, [userDetails]);
  function getAllScrutinizersBySupervisor() {
    loaderService.showLoader();
    apiClient
      .post(GET_SCRUTINIZER_BY_SUPERVISOR_ID,
        {
            "userID": userDetails?.id,

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setScrutinizerBySupervisor(response.data.users);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  const scrutinizersArray = scrutinizers?.users;

  const columns = [
    {
      field: 'id', headerName: 'S.No', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    {
      field: 'name', headerName: t('preReg.name'), width: 200,
      valueGetter: (params) => {

        if (params) {

          return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname

        } else return '-'

      }
    },
    { field: 'emailAddress', headerName: 'Email ID', width: 200 },
    { field: 'gender', headerName: 'Gender', width: 120 },
   role === ROLES.RegSuperVisor ? { field: 'preRegCount', headerName: 'Pre-Registration Count', width: 200 }
   :  { field: 'scrutinyCount', headerName: 'Scrutiny Count', width: 120, renderCell: (params) => { return (<Link to={params} onClick={() => { viewMappingDetails(params?.row?.id) }}>{params.value}</Link>) } } ,

  ];

  return (
    <>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG64</p>}
      
      <Card>
        <CardContent>
        <div hidden={showMapping}> 
          <div style={{ display: "inline-flex" }}>
            {/* <Typography variant="h4" sx={{ mb: 2 }}>
              <Fab component={RouterLink} to='./supervisorashboard' size="small" aria-label="back" title='Back'>
                <KeyboardArrowLeftRounded />
              </Fab>
            </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
            <div className="hitDetailsText">Scrutinizer Details</div>
          </div>
          {scrutinizersBySupervisor &&
            <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
              <DataGrid
                rows={scrutinizersBySupervisor}
                columns={columns}
                pageSize={10}
                getRowId={(row) => row?.id}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </Box>
            }

            </div>
            <div hidden={!showMapping} >
              <Typography variant="h4" sx={{ mb: 2 }}>
                <Fab component={RouterLink} to= '/registrationHome/supervisorDashboard' size="small" aria-label="back" title='Back' onClick={() => showMapping ? setShowMapping(false) : setShowMapping(true)} >
                  <KeyboardArrowLeftRounded />
                </Fab>
                      </Typography> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <ScrutinyDetails userid={scrutinizerID} role={ROLES.RegistrationScruitnizer} />
            </div>
        </CardContent>
      </Card>
     
    </>
 
  );
}
export default SuperVisorDashboard;

